import {
    CHALLENGES_REQUESTED,
    CHALLENGES_SUCCEEDED,
    CHALLENGES_FAILED,
    CHALLENGE_UPDATE_REQUESTED,
    CHALLENGE_UPDATE_SUCCEEDED,
    CHALLENGE_UPDATE_FAILED,
    PARTICIPATED_CHALLENGES_FAILED,
    PARTICIPATED_CHALLENGES_REQUESTED,
    PARTICIPATED_CHALLENGES_SUCCEEDED,
} from './constants';

export function challengesRequested() {
    return {
        type: CHALLENGES_REQUESTED,
        challengesLoading: true,
    };
}

export function challengesSucceeded(challenges) {
    return {
        type: CHALLENGES_SUCCEEDED,
        challenges,
        challengesLoading: false,
    };
}

export function challengesFailed(error) {
    return {
        type: CHALLENGES_FAILED,
        error,
        challengesLoading: false,
    };
}

export function participatedChallengesRequested() {
    return {
        type: PARTICIPATED_CHALLENGES_REQUESTED,
        challengesLoading: true,
    };
}

export function participatedChallengesSucceeded(challenges) {
    return {
        type: PARTICIPATED_CHALLENGES_SUCCEEDED,
        challenges,
        challengesLoading: false,
    };
}

export function participatedChallengesFailed(error) {
    return {
        type: PARTICIPATED_CHALLENGES_FAILED,
        error,
        challengesLoading: false,
    };
}

export function challengeUpdateRequested(challengeToUpdateIndex) {
    return {
        type: CHALLENGE_UPDATE_REQUESTED,
        challengeToUpdateIndex,
    };
}

export function challengeUpdateSucceeded(
    updatedChallenge,
    challengeToUpdateIndex,
) {
    return {
        type: CHALLENGE_UPDATE_SUCCEEDED,
        updatedChallenge,
        challengeToUpdateIndex,
        challengesLoading: false,
    };
}

export function challengeUpdateFailed(error) {
    return {
        type: CHALLENGE_UPDATE_FAILED,
        error,
        challengesLoading: false,
    };
}
